import React from "react";
import { ShinyButton } from "./ui/shiny-button";
import "./ContactSection.css";

const ContactSection = () => {
  return (
    <section id="ContactSection">
      <div className="contact-wrap">
        {/* centered title */}
        <h2 className="contact-main-heading">Contact Us</h2>

        <div className="contact-heading-line" />

        {/* centered form */}
        <form
          className="contact-form"
          name="contactForm"
          action="https://formspree.io/f/mdoqekan"
          method="POST"
        >
          <input
            type="text"
            name="name"
            required
            placeholder="Name"
            autoComplete="name"
            className="contact-field"
          />
          <input
            type="email"
            name="email"
            required
            placeholder="Email"
            autoComplete="email"
            autoCapitalize="none"
            className="contact-field"
          />
          <input
            type="tel"
            name="mobile"
            required
            placeholder="Phone"
            autoComplete="tel"
            pattern="\d{10}"
            maxLength="10"
            minLength="10"
            title="Please enter a valid 10-digit phone number."
            className="contact-field"
          />
          <textarea
            name="message"
            required
            placeholder="Message"
            rows="7"
            className="contact-field contact-field-message"
          />
          <ShinyButton className="contact-submit">Submit</ShinyButton>
        </form>
      </div>
    </section>
  );
};

export default ContactSection;
